<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛区信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>赛区信息详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">赛区信息</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="120px"
        :rules="queryFormRules"
        ref="queryFormRef"
      >
        <el-row :gutter="0">
          <el-col :span="8">
            <el-form-item label="赛区名称" prop="districtName">
              <el-input
                v-model="queryForm.districtName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="赛区编号" prop="districtNo">
              <el-input
                v-model="queryForm.districtNo"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="赛区电话" prop="districtTel">
              <el-input
                v-model="queryForm.districtTel"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛区类型" prop="divisionType">
              <el-select
                placeholder="请选择"
                v-model="queryForm.divisionType"
                style="width: 100%"
              >
                <el-option
                  v-for="item in divisionType"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="运营类型" prop="operationType">
              <el-select
                placeholder="请选择"
                v-model="queryForm.operationType"
                style="width: 100%"
              >
                <el-option
                  v-for="item in operationType"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛区区域" prop="regionType">
              <el-select
                placeholder="请选择"
                v-model="queryForm.regionType"
                style="width: 100%"
                @change="onRegionTypeChange"
              >
                <el-option
                  label="国内"
                  value="domestic"
                ></el-option>
                <el-option
                  label="海外"
                  value="overseas"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛区负责人" prop="principal">
              <el-select
                placeholder="请选择"
                v-loadMore="loadMore"
                v-model="queryForm.principal"
                style="width: 100%"
              >
                <el-option
                  v-for="item in principalList"
                  :key="item.id"
                  :label="item.userName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                v-model="queryForm.contactPhone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮箱" prop="contactEmail">
              <el-input
                v-model="queryForm.contactEmail"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="初赛晋级分数线" prop="earlyMatch">
              <el-input
                v-model="queryForm.earlyMatch"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="8">
            <el-form-item label="复赛晋级分数线" prop="repeatedMatch">
              <el-input
                v-model="queryForm.repeatedMatch"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="赛区地址" prop="districtAddress">
              <el-input
                v-model="queryForm.districtAddress"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛区介绍" prop="districtDescription">
              <el-input
                v-model="queryForm.districtDescription"
                placeholder="请输入"
                type="textarea"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="包含赛程" prop="raceScheduleTypeList">
              <el-select
                v-model="queryForm.raceScheduleTypeList"
                placeholder="请按顺序选择"
                multiple
                @change="$forceUpdate()"
                type="textarea"
                clearable
                style="width: 100%"
                :disabled="true"
              ><el-option
                v-for="item in raceScheduleList"
                :key="item.scheduleSort"
                :label="item.scheduleName"
                :value="item.id + ''">
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <!-- 海外赛区显示国家选择 -->
          <el-col :span="8" v-if="queryForm.regionType === 'overseas'">
            <el-form-item label="国家" prop="countryCode">
              <el-select
                v-model="queryForm.countryCode"
                placeholder="请选择国家"
                clearable
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row type="flex" justify="center">
        <el-col :span="4">
          <el-button
            type="primary"
            style="width: 100%"
            @click="saveDistrictInfoClicked"
            >保存赛区信息</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 绑定账号（仅海外赛区展示） -->
    <el-card style="margin-top: 15px" v-if="queryForm.regionType === 'overseas'">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">绑定账号</span>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="committeeAdminList"
        border
        stripe
        style="margin-top: 10px"
      >
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column label="赛区" prop="districtName"></el-table-column>
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column label="邮箱" prop="email"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { saveOrUpdateDistrict, queryErpUserList, getCountryList, queryOverseasCommitteeAdminList } from '@/http/api'
export default {
  data () {
    return {
      principalList: [],
      divisionType: this.$userInfo.divisionType(),
      operationType: this.$userInfo.operationType(),
      queryForm: JSON.parse(this.$route.query.districtData),
      queryFormRules: {
        districtName: [
          { required: true, message: '请输入赛区名称', trigger: 'blur' }
        ],
        districtTel: [
          { required: true, message: '请输入赛区电话', trigger: 'blur' }
        ],
        divisionType: [
          { required: true, message: '请选择赛区类型', trigger: 'change' }
        ],
        operationType: [
          { required: true, message: '请选择运营类型', trigger: 'change' }
        ],
        regionType: [
          { required: true, message: '请选择赛区区域', trigger: 'change' }
        ],
        principal: [
          { required: true, message: '请选择赛区负责人', trigger: 'change' }
        ],
        countryCode: [
          {
            validator: (rule, value, callback) => {
              if (this.queryForm.regionType === 'overseas' && !value) {
                callback(new Error('请选择国家'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      raceScheduleList: [],
      userInfoTotalPages: 0,
      getUserListForm: {
        pageNum: 1,
        pageSize: 10
      },
      countryList: [], // 国家列表
      regionType: this.$route.query.regionType || 'domestic', // 区域类型
      committeeAdminList: [] // 绑定账号列表
    }
  },
  created () {
    if (this.queryForm.id) {
      // console.log('raceScheduleTypeList', this.queryForm.raceScheduleType.split(','))
      this.queryForm.raceScheduleTypeList = this.queryForm.raceScheduleType.split(',')
    } else {
      // 需求：赛区包含赛程默认全赛程不可修改
      this.queryForm.raceScheduleTypeList = ['1', '2', '3', '4']
    }
    // 确保queryForm包含countryCode和regionType字段
    if (!this.queryForm.countryCode) {
      this.$set(this.queryForm, 'countryCode', '')
    }
    if (!this.queryForm.regionType) {
      this.$set(this.queryForm, 'regionType', this.regionType || 'domestic')
    }
    this.getDistrictData()
    this.getQueryErpUserList()
    this.raceScheduleList = this.$chnEngPublicRequest.querySeasonRaceSchedule(this, { }).then(value => { this.raceScheduleList = value })
    // 如果是海外赛区，获取国家列表
    if (this.queryForm.regionType === 'overseas') {
      this.getCountryList()
      this.getCommitteeAdminList()
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取赛区信息
    getDistrictData () {
      // queryDistrictPage().then((res) => {
      //   console.log('districtInfoData', res)
      //   this.queryForm = res.data
      // }).catch((err) => {
      //   console.log('err', err)
      // })
    },
    loadMore () {
      if (this.getUserListForm.pageNum + 1 >= this.userInfoTotalPages) return
      this.getUserListForm.pageNum++
      // 获取列表数据的方法
      this.getQueryErpUserList()
    },
    // 获取系统人员列表
    getQueryErpUserList () {
      queryErpUserList(this.getUserListForm).then((res) => {
        console.log('res', res)
        this.userInfoTotalPages = res.data.total
        this.principalList = [...this.principalList, ...res.data.list]
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 获取国家列表
    getCountryList () {
      getCountryList().then((res) => {
        console.log('countryList', res)
        this.countryList = res.data.data || res.data || []
      }).catch((err) => {
        console.log('获取国家列表失败', err)
        this.$message.error('获取国家列表失败')
      })
    },
    // 获取绑定账号列表（海外赛区）
    getCommitteeAdminList () {
      if (!this.queryForm.id) {
        this.committeeAdminList = []
        return
      }
      const params = {
        // 后端按需调整参数名称，这里默认使用districtId
        id: this.queryForm.id
      }
      queryOverseasCommitteeAdminList(params).then((res) => {
        console.log('queryOverseasCommitteeAdminList', res)
        const list = (res && res.data && (res.data.list || res.data)) || []
        this.committeeAdminList = Array.isArray(list) ? list : []
      }).catch((err) => {
        console.log('获取绑定账号列表失败', err)
        this.$message.error('获取绑定账号列表失败')
      })
    },
    // 赛区区域变化处理
    onRegionTypeChange (value) {
      if (value === 'overseas') {
        // 切换到海外时，获取国家列表
        this.getCountryList()
      } else {
        // 切换到国内时，清空国家选择
        this.queryForm.countryCode = ''
      }
      // 重新验证国家字段
      this.$nextTick(() => {
        this.$refs.queryFormRef.validateField('countryCode')
      })
    },
    // 保存赛区信息
    saveDistrictInfoClicked () {
      // 先进行表单验证
      this.$refs.queryFormRef.validate((valid) => {
        if (valid) {
          this.queryForm.raceScheduleType = this.queryForm.raceScheduleTypeList.toString()
          // regionType和countryCode字段已经在queryForm中，直接提交
          saveOrUpdateDistrict(this.queryForm).then((res) => {
            console.log('saveOrUpdateDistrict', res)
            this.$message.success('保存成功')
          }).catch((err) => {
            console.log('err', err)
          })
        } else {
          this.$message.error('请完善必填信息')
          return false
        }
      })
    }
  }
}
</script>

<style>
</style>
